import { ListedInstrument, WatchListInstrumentFull } from '@eih-netbroker/common';
import { useCallback } from 'react';
import { useLocale } from '../../../context/NbLocalizationContext';
import { useWatchList } from '../../../modules/watchlist/services/useWatchList';
import classes from './InstrumentSearchModalWatchlistPopover.module.scss';
import { InstrumentSearchModalWatchlistRow } from './InstrumentSearchModalWatchlistRow';

export interface InstrumentSearchModalWatchlistPopoverProps {
  instrument: ListedInstrument | null;
}

export const InstrumentSearchModalWatchlistPopover = ({ instrument }: InstrumentSearchModalWatchlistPopoverProps) => {
  const {
    watchListGroups,
    addInstrumentToWatchList,
    createOrUpdateWatchListGroup,
    deleteWatchListInstrumentFromGroup,
  } = useWatchList();

  const { translation } = useLocale();

  const onAdd = useCallback(
    async (watchListGroup: any, instrument: ListedInstrument) => {
      const newGroup = addInstrumentToWatchList(watchListGroup, instrument);
      await createOrUpdateWatchListGroup(newGroup);
    },
    [addInstrumentToWatchList, createOrUpdateWatchListGroup],
  );

  const onRemove = useCallback(
    async (watchListGroup: any, watchListInstrument: WatchListInstrumentFull) => {
      await deleteWatchListInstrumentFromGroup(watchListGroup, watchListInstrument);
    },
    [deleteWatchListInstrumentFromGroup],
  );

  return (
    <div className={classes.watchListPopover}>
      <span className={classes.watchListPopoverTitle}>{translation.instrument.saveToWatchlist.chooseWatchlist}</span>
      {watchListGroups.map(watchListGroup => (
        <InstrumentSearchModalWatchlistRow
          onAdd={onAdd}
          onRemove={onRemove}
          watchListGroup={watchListGroup}
          instrument={instrument}
          key={watchListGroup.id}
        />
      ))}
    </div>
  );
};
